import axios from 'axios';

export const defaultLogin = async (userName, password) => {
  const data = await axios.get(`https://api-ldc.goldenbuzz.in/api/User/SendOPT?${userName}=ripon008&password=${password}`);
  return data;
};
